export enum SearchFilterDayTimeType {
  ALL = 'all',
  MORNING = 'morning',
  AFTERNOON = 'afternoon',
}

export interface DayTimeOptionsProps {
  value: SearchFilterDayTimeType;
  title: string;
}

export const SearchFilterDayTimeMap: Record<SearchFilterDayTimeType, string> = {
  [SearchFilterDayTimeType.ALL]: 'Todos',
  [SearchFilterDayTimeType.MORNING]: 'Manhã',
  [SearchFilterDayTimeType.AFTERNOON]: 'Tarde',
};
